<template>
    <div id="app-readonly-table-map">
        <v-data-table
            :headers="this.parentData.headers"
            :items="this.parentData.records"
            v-bind:pagination.sync="pagination"
            class="elevation-1 fixed-header"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left" nowrap>{{ props.item.employee_name }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.company_name }}</td>

                <td class="text-xs-left" v-if="props.item.localtime_at">{{ props.item.localtime_at | formatUxDate }}</td>
                <td class="text-xs-left" v-else nowrap>{{ props.item.clock_date | formatUxDate }}</td>

                <td class="text-xs-left" v-if="props.item.localtime_at" nowrap>{{ props.item.localtime_at | formatUxTime }}</td>
                <td class="text-xs-left" v-else nowrap>{{ props.item.clock_time | formatUxTime }}</td>

                <td class="text-xs-left" v-if="props.item.clocking_at" nowrap>{{ props.item.clocking_at | formatUxTime }}</td>

                <td class="text-xs-left">{{ props.item.clock_in_out | toggleInOut }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.reason_name }}</td>
                <td class="text-xs-left">{{ props.item.project_name }}</td>
                <td class="text-xs-center">{{ props.item.id_number }}</td>
                <td class="text-xs-left" nowrap>
                    <a slot="activator" @click="openMap(props.item.clocking_lat, props.item.clocking_lon)">{{ props.item.location }}</a>
                    <v-dialog v-model="dialogMap" max-width="500px">
                        <v-card>
                            <GmapMap
                            v-bind:center="centerOfMap"
                            v-bind:zoom="18"
                            map-type-id="roadmap"
                            style="width: 500px; height: 500px"
                            >
                            <GmapMarker
                                v-bind:key="index"
                                v-for="(m, index) in markers"
                                v-bind:position="m.position"
                                v-bind:clickable="false"
                                v-bind:draggable="true"
                                @click="centerOfMap=m.position"
                            />
                            </GmapMap>
                        </v-card>
                        <v-card-actions class="justify-center">
                            <v-btn @click="dialogMap = false">CLOSE</v-btn>
                        </v-card-actions>
                    </v-dialog>
                </td>
                <!-- <td class="text-xs-left" nowrap>
                  <a slot="activator" @click="openPhoto(props.item.photo_clockin)" v-if="props.item.photo_clockin">
                    <v-icon>image</v-icon>
                  </a>
                </td>
                <td class="text-xs-left" nowrap>
                  <a slot="activator" @click="openPhoto(props.item.photo_clockout)" v-if="props.item.photo_clockout">
                    <v-icon>image</v-icon>
                  </a>
                </td> -->
                <td class="text-xs-left" nowrap>
                  <a slot="activator" @click="openPhoto(props.item.id, 'photo_clockin')">
                    <v-icon>image</v-icon>
                  </a>
                </td>
                <td class="text-xs-left" nowrap>
                  <a slot="activator" @click="openPhoto(props.item.id, 'photo_clockout')">
                    <v-icon>image</v-icon>
                  </a>
                </td>
                <td class="text-xs-left" nowrap>{{ props.item.geolocation_code }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.geolocation_name }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.t2hr_sync_time }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.t2hr_sync_message }}</td>
            </template>

            <template slot="pageText" slot-scope="props">
                Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                pagination: {'sortBy': 'clock_date', 'sortBy': 'clock_time', 'descending': true, 'rowPerPage': -1},
                dialogMap: false,
                dialogPhoto: false,
                dialogPhotoIndex: 0,
                centerOfMap: {lat: 10, lng: 10},
                markers: [],
            }
        },

        props: {
            parentData: Object
        },

        methods: {
            openMap(clklat, clklon){
            this.centerOfMap = {lat: clklat, lng: clklon}
            //this.markers.push({position: {lat: clklat, lng: clklon}})
            this.markers = [{position: {lat: clklat, lng: clklon}}]
            this.dialogMap = !this.dialogMap
           },
        //    openPhoto(photo) {
        //     console.log(photo);
        //     this.$emit('update-prop', photo);
        //    },
           openPhoto(photo, column) {
            let vm = this;
            let rec;
            axios.get(this.$store.getters.rootAPI + '/clock/photo/' + column + '/' + photo)
            .then((response) => {
                rec = response.data.rec[0].photo;
                // console.log(rec);
                if (rec) {
                    vm.$emit('update-prop', rec);
                } else {
                    alert('No image found.');
                }
                })
            .catch((error) => {
                vm.status = 'An error occured.' + error;
            })
           },
        }
    }
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ReadOnlyTableMaps.vue